@if (!drawerMode) {
  <app-page-breadcrumb [pageTitle]="pageTitle"></app-page-breadcrumb>
}

<ng-container
  *ngIf="drawerMode; then formBody; else pageWrapper"
></ng-container>

<ng-template #pageWrapper>
  <div class="grid grid-cols-1 gap-6">
    <app-component-card
      [title]="pageTitle"
      desc="Configure la regla de descuento"
    >
      <ng-container *ngTemplateOutlet="formBody"></ng-container>
    </app-component-card>
  </div>
</ng-template>

<ng-template #formBody>
  <div [class.p-6]="drawerMode">
    @if (loading) {
      <div class="flex justify-center items-center py-12">
        <div
          class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"
        ></div>
        <span class="ml-3 text-gray-500 dark:text-gray-400"
          >Cargando datos...</span
        >
      </div>
    }

    @if (error) {
      <div
        class="mb-4 p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20"
      >
        <p class="text-sm text-error-600 dark:text-error-400">{{ error }}</p>
      </div>
    }

    @if (!loading) {
      <form
        [formGroup]="form"
        (ngSubmit)="guardar()"
        class="space-y-5"
      >
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-5">
          <div>
            <label
              class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
            >
              Tipo de regla <span class="text-error-500">*</span>
            </label>
            <select
              formControlName="ruleType"
              class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
            >
              <option value="volume">Volumen</option>
              <option value="contractual">Contractual</option>
              <option value="coupon">Cupón</option>
              <option value="min_price">Precio mínimo</option>
            </select>
          </div>

          @if (ruleType !== 'min_price') {
            <div>
              <label
                class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
              >
                Tipo de descuento
              </label>
              <select
                formControlName="discountType"
                class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
              >
                <option value="percent">Porcentaje</option>
                <option value="fixed_amount">Monto fijo</option>
              </select>
            </div>
          }

          @if (ruleType !== 'min_price' && ruleType !== 'coupon') {
            <div class="sm:col-span-2">
              <label
                class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
              >
                Valor ({{
                  form.get('discountType')?.value === 'percent' ? '%' : '$'
                }})
              </label>
              <input
                type="number"
                formControlName="discountValue"
                min="0"
                step="0.01"
                placeholder="10"
                class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
              />
            </div>
          }

          @if (ruleType === 'volume') {
            <div>
              <label
                class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
                >Cantidad mínima</label
              >
              <input
                type="number"
                formControlName="minQuantity"
                min="0"
                placeholder="1"
                class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
              />
            </div>
            <div>
              <label
                class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
                >Cantidad máxima</label
              >
              <input
                type="number"
                formControlName="maxQuantity"
                min="0"
                placeholder="Sin límite"
                class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
              />
            </div>
          }

          @if (ruleType === 'contractual') {
            <div>
              <label
                class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
                >Contacto</label
              >
              <div class="relative">
                <input
                  type="text"
                  [value]="contactSearchTerm"
                  (input)="onContactSearchInput($any($event.target).value)"
                  (blur)="hideDropdownDelayed()"
                  (keydown.enter)="onContactSearchEnter($event)"
                  placeholder="Buscar contacto... (Enter para ver todos)"
                  class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
                />

                @if (searchingContacts) {
                  <div class="absolute right-3 top-3">
                    <div
                      class="animate-spin rounded-full h-4 w-4 border-b-2 border-brand-500"
                    ></div>
                  </div>
                }

                @if (showContactDropdown && contactSearchResults.length > 0) {
                  <div
                    class="absolute z-50 mt-1 w-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg max-h-48 overflow-y-auto"
                  >
                    @for (contact of contactSearchResults; track contact.id) {
                      <button
                        type="button"
                        (click)="selectContact(contact)"
                        class="w-full flex items-center gap-3 px-3 py-2 hover:bg-gray-50 dark:hover:bg-gray-700 text-left transition-colors"
                      >
                        <div
                          class="flex h-8 w-8 items-center justify-center rounded-full text-xs font-semibold {{
                            getContactAvatarColor(contact)
                          }}"
                        >
                          {{ getContactInitials(contact) }}
                        </div>

                        <div class="flex-1 min-w-0">
                          <p
                            class="text-sm font-medium text-gray-900 dark:text-white truncate"
                          >
                            {{ contact.fullname }} {{ contact.lastname }}
                          </p>

                          <p
                            class="text-xs text-gray-500 dark:text-gray-400 truncate"
                          >
                            {{ contact.mail }}
                          </p>
                        </div>
                      </button>
                    }
                  </div>
                }
              </div>
            </div>
          }

          @if (ruleType === 'coupon') {
            <div>
              <label
                class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
              >
                Código de cupón <span class="text-error-500">*</span>
              </label>
              <input
                type="text"
                formControlName="couponCode"
                placeholder="SUMMER20"
                maxlength="50"
                [class.border-error-500]="hasError('couponCode')"
                [class.border-gray-300]="!hasError('couponCode')"
                class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
              />
              @if (hasError('couponCode')) {
                <p class="mt-1.5 text-sm text-error-500">
                  {{ getError('couponCode') }}
                </p>
              } @else {
                <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
                  {{ form.get('couponCode')?.value?.length || 0 }}/50
                  caracteres.
                </p>
              }
            </div>
            <div>
              <label
                class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
                >Máximo de usos</label
              >
              <input
                type="number"
                formControlName="maxUses"
                min="1"
                placeholder="Sin límite"
                class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
              />
            </div>
            <div class="sm:col-span-2">
              <label
                class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
              >
                Valor del cupón ({{
                  form.get('discountType')?.value === 'percent' ? '%' : '$'
                }})
              </label>
              <input
                type="number"
                formControlName="discountValue"
                min="0"
                step="0.01"
                placeholder="15"
                class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
              />
            </div>
          }

          @if (ruleType === 'min_price') {
            <div>
              <label
                class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
              >
                Precio mínimo de venta
              </label>
              <input
                type="number"
                formControlName="minSalePrice"
                min="0"
                step="0.01"
                placeholder="0.00"
                class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
              />
            </div>
          }

          <div>
            <label
              class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
              >Válido desde</label
            >
            <input
              type="date"
              formControlName="validFrom"
              [min]="minDatetimeLocal"
              (click)="$any($event.target).showPicker?.()"
              (focus)="$any($event.target).showPicker?.()"
              class="dark:bg-dark-900 dark:scheme-dark h-11 w-full cursor-pointer rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 dark:bg-gray-900 dark:text-white/90"
              [class.border-error-500]="hasDateRangeError"
              [class.border-gray-300]="!hasDateRangeError"
              [class.dark:border-gray-700]="!hasDateRangeError"
            />
          </div>
          <div>
            <label
              class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
              >Válido hasta</label
            >
            <input
              type="date"
              formControlName="validUntil"
              [min]="minDatetimeLocal"
              (click)="$any($event.target).showPicker?.()"
              (focus)="$any($event.target).showPicker?.()"
              class="dark:bg-dark-900 dark:scheme-dark h-11 w-full cursor-pointer rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 dark:bg-gray-900 dark:text-white/90"
              [class.border-error-500]="hasDateRangeError"
              [class.border-gray-300]="!hasDateRangeError"
              [class.dark:border-gray-700]="!hasDateRangeError"
            />

            @if (hasDateRangeError) {
              <p
                class="mt-1.5 text-sm text-error-500 flex items-center gap-1.5"
              >
                <svg
                  class="w-4 h-4 shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  ></path>
                </svg>
                La fecha "Válido hasta" no puede ser anterior a "Válido desde".
              </p>
            }
          </div>

          <div class="sm:col-span-2">
            <label
              class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
              >Producto<span class="text-error-500">*</span></label
            >
            <div class="relative">
              <input
                type="text"
                [(ngModel)]="productSearch"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="buscarProductos()"
                (focus)="onFocusProducto()"
                (blur)="onBlurProducto()"
                [class.border-error-500]="hasError('productId')"
                [class.border-gray-300]="!hasError('productId')"
                placeholder="Buscar producto..."
                class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
              />
              @if (hasError('productId')) {
                <p class="mt-1.5 text-sm text-error-500">
                  {{ getError('productId') }}
                </p>
              }
              @if (productResults.length > 0) {
                <div
                  class="absolute z-10 w-full mt-1 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-md shadow-lg max-h-40 overflow-y-auto"
                >
                  @for (prod of productResults; track prod.id) {
                    <button
                      type="button"
                      (click)="seleccionarProducto(prod)"
                      class="w-full text-left px-3 py-2 text-xs hover:bg-brand-50 dark:hover:bg-brand-900/20"
                    >
                      <span class="font-medium text-gray-800 dark:text-white">{{
                        prod.name
                      }}</span>
                      <span class="text-gray-400 ml-2">({{ prod.sku }})</span>
                    </button>
                  }
                </div>
              }
            </div>
            @if (selectedProduct) {
              <div class="mt-1 flex items-center gap-2">
                <span
                  class="text-xs text-brand-600 dark:text-brand-400 font-medium"
                  >{{ selectedProduct.name }}</span
                >
                <button
                  type="button"
                  (click)="limpiarProducto()"
                  class="text-gray-400 hover:text-gray-600"
                >
                  <svg
                    class="w-3 h-3"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    ></path>
                  </svg>
                </button>
              </div>
            }
          </div>

          <div class="sm:col-span-2">
            <label
              class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
              >Descripción</label
            >
            <input
              type="text"
              formControlName="description"
              placeholder="Descripción interna"
              class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
            />
          </div>
        </div>

        <div
          class="flex items-center justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700"
        >
          <app-button
            variant="outline"
            type="button"
            (btnClick)="cancelar()"
            >Cancelar</app-button
          >
          <app-button
            variant="primary"
            type="button"
            (btnClick)="guardar()"
            [disabled]="saving || form.invalid"
          >
            {{
              saving ? 'Guardando...' : isEditing ? 'Actualizar' : 'Crear Regla'
            }}
          </app-button>
        </div>
      </form>
    }
  </div>
</ng-template>
